import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListItemDirective } from './list-item.directive';

@NgModule({
  declarations: [
    ListItemDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ListItemDirective
  ]
})
export class ListItemModule { }
